<template>
  <van-popup v-if="showLoginDialog" :value="true" style="width: 80%" round :close-on-click-overlay="false">
    <div v-if='loginForm.loginType==="smsCode"' style="display: flex;flex-direction: column;border-radius: 10px;padding: 10px 0">
      <div style="color: black;font-size: 20px;padding: 10px 0;text-align: center;margin-bottom: 10px;font-weight: 600">验证码登录</div>
      <van-field
        label=""
        v-model="loginForm.phone"
        center
        placeholder="请输入手机号"
        :border="true"
        type="digit"
        maxlength="11"
        left-icon="phone"
      />
      <van-field
        label=""
        v-model="loginForm.smsCode"
        center
        clearable
        placeholder="请输入验证码"
        :border="true"
        use-button-slot
        type="digit"
        maxlength="6"
        left-icon="lock"
      >
        <el-button
          slot="button"
          type="text"
          style="font-size: 16px"
          :disabled="disabled=!show"
          @click="sendCode()">
          <span v-show="show">获取验证码</span>
          <span v-show="!show" class="count">{{ count }} 秒</span>
        </el-button>
      </van-field>
      <div style="text-align: right;padding-top: 10px;padding-right: 20px;color: #1bbc9b;cursor: pointer;font-size: 16px" @click="changeLoginType">密码登录</div>
      <van-button
        slot="button"
        size="large"
        type="primary"
        color="#1AC09E"
        round
        style="width: 90%;margin: 50px auto 10px auto;"
        @click="handleLogin()">
        登录
      </van-button>
    </div>
    <div v-if='loginForm.loginType==="password"' style="display: flex;flex-direction: column;border-radius: 10px;padding: 10px 0">
      <div style="color: black;font-size: 20px;padding: 10px 0;text-align: center;margin-bottom: 10px;font-weight: 600">密码登录</div>
      <van-field
        label=""
        v-model="loginForm.username"
        center
        placeholder="请输入账号"
        :border="true"
        left-icon="phone"
      />
      <van-field
        label=""
        v-model="loginForm.password"
        center
        clearable
        placeholder="请输入密码"
        type="password"
        :border="true"
        maxlength="30"
        left-icon="lock"
      >
      </van-field>
      <div style="text-align: right;padding-top: 10px;padding-right: 20px;color: #1bbc9b;cursor: pointer;font-size: 16px" @click="changeLoginType">验证码登录</div>
      <van-button
        slot="button"
        size="large"
        type="primary"
        color="#1AC09E"
        round
        style="width: 90%;margin: 50px auto 10px auto;"
        @click="handleLogin()">
        登录
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import md5 from 'md5'

export default {
  name: "login",
  data() {
    return {
      showLoginDialog: false,
      loginForm: {
        loginType: 'password',
        appType: 1,
        deviceType: 1,
        phone: '',
        smsCode: '',

        username: '',
        password: '',
      },
      count: '',
      show: true,
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.server.isLogin
    }
  },
  watch: {
    isLogin(val) {
      this.showLoginDialog = !val
    }
  },
  methods: {
    changeLoginType() {
      this.loginForm.loginType = this.loginForm.loginType === "password" ? "smsCode" : "password"
    },
    isValidPhoneNumber(phoneNumber) {
      return /^1\d{10}$/.test(phoneNumber);
    },
    sendCode() {
      if (!this.isValidPhoneNumber(this.loginForm.phone)) {
        this.$toast("请输入正确的手机号")
        return
      }
      this.$store.dispatch("server", {
        type: "post",
        url: '/base/sms/sendPhoneCode',
        data: {
          type: 1,
          phone: this.loginForm.phone
        }
      }).then((response) => {
        if (response.data.status === 200) {
          this.$toast("验证码发送成功")
          const TIME_COUNT = 60 // 更改倒计时时间
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer) // 清除定时器
                this.timer = null
              }
            }, 1000)
          }
        } else {
          this.$toast(response.data.msg)
        }
      })
    },
    handleLogin() {
      if (this.loginForm.loginType === "smsCode") {
        if (!this.isValidPhoneNumber(this.loginForm.phone)) {
          this.$toast("请输入正确的手机号")
          return
        }
        if (!this.loginForm.smsCode) {
          this.$toast("请输入验证码")
          return
        }
      } else if (this.loginForm.loginType === "password") {
        if (!this.loginForm.username) {
          this.$toast("请输入账号")
          return
        }
        if (!this.loginForm.password) {
          this.$toast("请输入密码")
          return
        }
      }

      const data = Object.assign({}, this.loginForm)
      data.password = md5(this.loginForm.password)

      this.$store.dispatch("server", {
        type: "post",
        url: '/ums/oauth/login',
        data: data
      }).then((response) => {
        if (response.data.status === 200) {
          let loginInfo = response.data.data;
          this.$store.commit("GET_IS_LOGIN", true);
          localStorage.setItem("token", loginInfo.tokenHead + loginInfo.token);
          location.reload()
        } else {
          this.$toast(response.data.msg)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
> > > .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
  font-size: 22px;
}

> > > .van-field__control {
  font-size: 16px;
  padding-left: 5px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/body/viewh/login/index.vue